import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const Paperless: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
				<path
					fill="none"
					stroke="#A09FA7"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5m6 2h4m-6 4h2m-2 4h4M3 3l18 18"
				/>
			</svg>
		</div>
	);
};
